import { declarationMerchandise, declarationParty, paymentMethod } from "../component/options"

const print7501Form = [
  {
    name: 'paymentMethod',
    label: 'Payment Method',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '6',
    required: true,
    disabled: false,
    icon: undefined,
    sizeProp: { xs: 12, sm: 12, md: 12 }
  },
  {
    name: 'summaryDate',
    label: 'Summary Date',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
    sizeProp: { xs: 12, sm: 12, md: 12 }
  },
  {
    name: 'signatureDate',
    label: 'Signature Date',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
    sizeProp: { xs: 12, sm: 12, md: 12 }
  },
  {
    name: 'declarationParty',
    label: 'I declare that I am the',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
    sizeProp: { xs: 12, sm: 12, md: 12 }
  },

  {
    name: 'declarationMerchandise',
    label: 'I further declare that the merchandise',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
    sizeProp: { xs: 12, sm: 12, md: 12 }
  },
]

const optionsMap = {
  paymentMethod: paymentMethod,
  declarationParty: declarationParty,
  declarationMerchandise: declarationMerchandise,
}

export { optionsMap, print7501Form }
